import { getAllSheetsFromXLS } from '../../utils/getAllSheetsFromXLS';
import {
  checkVariables,
  parseDataSheet,
} from '../../utils/taInstrumentsUtilities.js';

export function dscParseTAInstrumentsXLS(blob, options = {}) {
  const { keepUndefined = false } = options;
  const xlsSheets = getAllSheetsFromXLS(blob);

  const sheets = [];
  for (let xlsSheet of xlsSheets) {
    if (xlsSheet.sheetName === 'Details') continue;
    sheets.push({
      name: xlsSheet.sheetName,
      variables: getVariables([xlsSheet], { keepUndefined }),
    });
  }

  return {
    meta: getMeta(xlsSheets),
    variables: getVariables(xlsSheets, { keepUndefined }),
    sheets,
  };
}

function getMeta(sheets) {
  const sheet = sheets.find((sheet) => sheet.sheetName === 'Details');
  if (!sheet) {
    return {};
  }
  const meta = {};
  for (let datum of sheet.data) {
    meta[datum[0]] = datum[1];
  }
  return meta;
}

function getVariables(sheets, options = {}) {
  const { keepUndefined } = options;
  sheets = sheets.filter((sheet) => sheet.sheetName !== 'Details');

  const variables = {
    t: {
      symbol: 't',
      label: 'Time',
      units: 'min',
      data: [],
    },
    x: {
      symbol: 'x',
      label: 'Temperature',
      units: '°C',
      data: [],
    },
    y: {
      symbol: 'y',
      label: 'Heat Flow (Normalized)',
      units: 'W/g',
      data: [],
    },
  };

  for (let sheet of sheets) {
    const parsed = parseDataSheet(sheet, { keepUndefined });
    checkVariables(parsed, variables);
    variables.t.data = variables.t.data.concat(parsed[0].data);
    variables.x.data = variables.x.data.concat(parsed[1].data);
    variables.y.data = variables.y.data.concat(parsed[2].data);
  }
  return variables;
}
